import React, { useMemo } from "react";
import FormFactory from "components/FormFactory";
import { Row, Col } from "antd";
import { withErrorBoundary } from "components/ErrorBoundary";
import FileBrowserField from "components/FormFactory/fields/FileBrowserField";
import commonMessages from "src/commonMessages";

const validateMessages = {
  required: "%s is required",
  array: {
    max: "%s cannot contain more than %s file",
  },
};

const GenericUploadForm = ({
  formName = "genericUploadForm",
  onFieldsChange,
  onSubmit,
  hideModal,
  hideSubmitButton = false,
  intl,
  isUploadPending,
  uploadLabel,
  submitButtonText,
  fileFieldName = "upload",
  required = true,
  disabled = false,
  maxFiles,
}) => {
  const Form = useMemo(() => {
    return FormFactory.create({
      name: formName,
      onFieldsChange,
      validateMessages,
    });
  }, [formName, onFieldsChange]);

  const label = uploadLabel || intl.formatMessage(commonMessages.upload);
  const saveText = submitButtonText || intl.formatMessage(commonMessages.save);

  return (
    <Form
      submitButtonText={saveText}
      hideSubmitButton={hideSubmitButton}
      onSubmit={onSubmit}
      isLoading={isUploadPending}
      hideCancelButton={false}
      onCancel={hideModal}
    >
      <Row gutter={24}>
        <Col span={9}>
          <FileBrowserField
            name={fileFieldName}
            label={label}
            required={required}
            disabled={disabled}
            maxFiles={maxFiles}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default withErrorBoundary(GenericUploadForm);
